import { render, staticRenderFns } from "./adduser.vue?vue&type=template&id=26615df7"
import script from "./adduser.vue?vue&type=script&lang=js"
export * from "./adduser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports